
const getters = {
    sidebar: state => state.app.sidebar,
    visitedViews: state => state.app.visitedViews, //快速导航tab
  };
  export default getters
  


// WEBPACK FOOTER //
// ./src/store/getters.js